<template>
    <section class="banner-primary" style="position:relative">
        <div class="theme1">
            <div class="primaryBanner" :style="{backgroundImage: `url(${banner})`}">
                <div class="contentBanner">
                    <img :src="logoBanner" alt="Logo Weflix"  style="height: 100px;"/>
                    <h1>{{titleBanner}}</h1>
                    <p>{{descriptionBanner}}</p>
                </div>
            </div>
            <div class="degrade"></div>
        </div>
        <div class="theme2"  v-if="false">
            <div class="primaryBanner" :style="{backgroundImage: `url(${require('@/assets/Weflix/Site/ThemeNetflix/testebg.webp')})`}">
                <div class="contentBanner">
                    <img :src="logoBanner" alt="Logo Weflix"  style="height: 200px;"/>
                    <h1>{{titleBanner}}</h1>
                    <p>{{descriptionBanner}}</p>
                </div>
            </div>
            <div class="degrade"></div>
        </div>
    </section>
       
</template>

<script>
import { mapState } from 'vuex';

export default {
    data() {
        return {
            titleBanner: '',
            descriptionBanner: '',
            logoBanner: '',
            banner: ''
        }
    },
    computed: {
        ...mapState(['finalWebsite', 'contentSiteWeflix']),
    },
    watch: {
        finalWebsite: {
            immediate: true,
            handler(newValue) {
                if (newValue) {
                    this.titleBanner = newValue.nome || '';
                    this.descriptionBanner = newValue.description || '';
                    this.logoBanner = newValue.logoFinal || '';
                }
            }
        },
        contentSiteWeflix: {
            immediate: true,
            handler(newValue) {
                if (newValue) {
                    this.banner = newValue.pathImageFinal || '';
                }
            }
        }
    },
}
</script>

<style scoped>  
.primaryBanner{
    height:800px;
    width: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    position: relative;
    padding-bottom: 64px;
    padding-top: 64px;
}
.degrade{
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 10;
    top: 0px;
    left: 0px;
    background-image: linear-gradient(rgba(0, 0, 0, 0), rgb(0, 0, 0));
}
.contentBanner {
    position: absolute;
    width: 100%;
    z-index: 11;
    top: 20%;
    left: 5%;
    text-align: left;
    max-width: 40%;
}
.contentBanner h1 {
    color: white;
    margin-top: 50px;
    font-size: 50px;
}
.contentBanner p {
    color: white;
    font-size: 18px;
}
@media only screen and (max-width: 600px) {
    .contentBanner {
        top: 20% !important;
        width: 86% !important;
        left: 7% !important;
        max-width: 100% !important;
    }
    .contentBanner h1 {
        font-size: 30px;
        margin-top: 20px;
    }
    .contentBanner p {
        font-size: 14px;
        padding: 0px;
    }
    .primaryBanner {
        height: 400px;

    }
}
@media only screen and (max-width: 1500px) and (min-width: 1200px) {
    .banner-primary .itemVideoCollections.cards {
        width: 98%;
        margin: 5% auto;

    }
    .banner-primary .contentBanner {
        width: 98% !important;
        left: 5% !important;

    }
}
</style>
